// extracted by mini-css-extract-plugin
export default {"navBar":"70px","sidePanelWidth":"500px","sidePanelPadding":"60vh","video":"video_video__R0Qa5"};